module.exports = "<div id=\"tinyFormGroup\" class=\"form-group\">\n    <div class=\"hidden\">\n        <textarea id=\"baseTextArea\">{{htmlContent}}</textarea>\n    </div>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/tinymce/view.html
 ** module id = 948
 ** module chunks = 0
 **/